import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LocaleValue } from '@hjc/masterdata-types';
import { TranslateModule } from '@ngx-translate/core';
import { AddPriceResult } from '@pages/pricing/components/add-price/add-price.component';

@Component({
  selector: 'md-price-list',
  templateUrl: './price-list.component.html',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CommonModule, TranslateModule],
  styleUrls: ['./price-list.component.scss']
})
export class PriceListComponent {
  prices = input<AddPriceResult[]>([]);
  title = input<string>('');
  itemName = input<string>('');

  edit = output<AddPriceResult>();
  delete = output<AddPriceResult>();

  lang: LocaleValue = 'fi';

  editPrice(price: AddPriceResult): void {
    this.edit.emit(price);
  }

  deletePrice(price: AddPriceResult): void {
    this.delete.emit(price);
  }
}
